





























































import { Component, Vue, Prop } from "vue-property-decorator";
import { MESSAGE } from "@/model/Message";
@Component
export default class JibaiseikiDialog extends Vue {
  @Prop() code: string;
  @Prop() value: number;
  @Prop({ default: false })
  appendToBody: string;
  showDialog: boolean = false;
  tableData: any = [];
  months: string[] = [];
  codeSelected: string = "";
  valueSelected: string = "";
  hasData: boolean = false;
  loading: boolean = true;
  loadingText: string = MESSAGE.Loading;
  errorMessage: string = "";

  created() {
    this.codeSelected = this.code;
    if (this.value) {
      this.valueSelected = this.value.toString();
    }
  }

  selectJibaiseiki(code: string, value: string, month: string) {
    this.codeSelected = code;
    this.valueSelected = value;
    this.$emit("onJibaiseiki", {
      code,
      value: +value,
      month: month.replace("m", "")
    });
    this.onClose();
  }

  cellClassName(code: string, cell: any) {
    if (cell.value == "0") {
      return "cell-disabled";
    }
    if (code == this.codeSelected && cell.value == this.valueSelected) {
      return "selected";
    }
    return "pointer";
  }

  setTableData(data: any) {
    if (data.length > 0) {
      this.$set(this, "hasData", true);
      this.$set(this, "tableData", data);
      let months = Object.keys(this.tableData[0]).slice(2, 8);
      this.$set(this, "months", months);
    }
  }

  onOpen() {
    this.showDialog = true;
    this.errorMessage = "";
    this.codeSelected = this.code;
  }

  onClose() {
    this.showDialog = false;
  }

  onDialog() {
    this.codeSelected = this.code;
    if (this.value) {
      this.valueSelected = this.value.toString();
    }
  }

  clearSelData() {
    this.codeSelected = "";
    this.valueSelected = "";
  }

  getDataError(error: string) {
    this.loading = false;
    this.errorMessage = error;
  }
}
